var map = {
	"./0000ff.png": 2640,
	"./00ff00.png": 6896,
	"./1.png": 8371,
	"./2.png": 1512,
	"./3.png": 1457,
	"./808080.png": 1656,
	"./airplan_incident.png": 1354,
	"./airplane.png": 2314,
	"./airport.png": 5223,
	"./bandara.png": 2515,
	"./basarnas.png": 4923,
	"./biohazard2.png": 2236,
	"./blue.png": 8096,
	"./bnpb.png": 9918,
	"./bpbd.png": 2268,
	"./bus.png": 6204,
	"./center2.png": 1233,
	"./cnn.png": 3837,
	"./cold_wave.png": 3684,
	"./cyclone.png": 1397,
	"./dapur.png": 2616,
	"./drought.png": 6975,
	"./earthquake.png": 4791,
	"./epidemic.png": 1278,
	"./extraan.gif": 1390,
	"./feher.gif": 9373,
	"./feher_lst.gif": 2169,
	"./ff0000.png": 512,
	"./ff69b4.png": 9933,
	"./ffa500.png": 5782,
	"./ffff00.png": 3328,
	"./fire.png": 5548,
	"./flash_flood.png": 3573,
	"./flood.png": 502,
	"./gadamusa.png": 9195,
	"./garuda.png": 2338,
	"./gereja.png": 3308,
	"./green.png": 467,
	"./grey.png": 9125,
	"./heatwave.png": 9857,
	"./heavy_rain.png": 7142,
	"./insect_infestation.png": 8335,
	"./jawa_tengah/kab_banjarnegara.png": 9107,
	"./jawa_tengah/kab_banyumas.png": 5007,
	"./jawa_tengah/kab_batang.png": 5414,
	"./jawa_tengah/kab_blora.png": 6471,
	"./jawa_tengah/kab_boyolali.png": 2764,
	"./jawa_tengah/kab_brebes.png": 4920,
	"./jawa_tengah/kab_cilacap.png": 2926,
	"./jawa_tengah/kab_demak.png": 9503,
	"./jawa_tengah/kab_grobogan.png": 7182,
	"./jawa_tengah/kab_jepara.png": 3436,
	"./jawa_tengah/kab_karanganyar.png": 1184,
	"./jawa_tengah/kab_kebumen.png": 5224,
	"./jawa_tengah/kab_kendal.png": 464,
	"./jawa_tengah/kab_klaten.png": 4382,
	"./jawa_tengah/kab_kudus.png": 1249,
	"./jawa_tengah/kab_magelang.png": 8551,
	"./jawa_tengah/kab_pati.png": 4485,
	"./jawa_tengah/kab_pekalongan.png": 8567,
	"./jawa_tengah/kab_pemalang.png": 9034,
	"./jawa_tengah/kab_purbalingga.png": 2719,
	"./jawa_tengah/kab_purworejo.png": 2884,
	"./jawa_tengah/kab_rembang.png": 7843,
	"./jawa_tengah/kab_semarang.png": 749,
	"./jawa_tengah/kab_sragen.png": 7603,
	"./jawa_tengah/kab_sukoharjo.png": 5327,
	"./jawa_tengah/kab_tegal.png": 3294,
	"./jawa_tengah/kab_temanggung.png": 8402,
	"./jawa_tengah/kab_wonogiri.png": 8213,
	"./jawa_tengah/kab_wonosobo.png": 3817,
	"./jawa_tengah/kota_magelang.png": 5974,
	"./jawa_tengah/kota_pekalongan.png": 2878,
	"./jawa_tengah/kota_salatiga.png": 804,
	"./jawa_tengah/kota_semarang.png": 4376,
	"./jawa_tengah/kota_surakarta.png": 8420,
	"./jawa_tengah/kota_tegal.png": 2065,
	"./kereta_api.png": 7255,
	"./klinik.png": 3256,
	"./kompastv.png": 5167,
	"./landslide.png": 9812,
	"./locust_infestation.png": 8597,
	"./mapala.png": 5658,
	"./masjid.png": 1766,
	"./metrotv.png": 1211,
	"./motor.png": 3953,
	"./nuclear_accident.png": 5034,
	"./orange.png": 8198,
	"./orari.png": 3225,
	"./photo.png": 3934,
	"./photo_blue.png": 5935,
	"./photo_green.png": 7514,
	"./photo_red.png": 9550,
	"./pink.png": 800,
	"./pln.png": 9496,
	"./pmi.png": 4928,
	"./point.png": 5124,
	"./polri.png": 948,
	"./pvmbg.png": 5400,
	"./rapi.png": 5490,
	"./red.png": 499,
	"./refugee.png": 8155,
	"./refugees.png": 5736,
	"./relawan.png": 5226,
	"./rs.png": 7537,
	"./sar.png": 5412,
	"./sd.png": 6801,
	"./ship.png": 2250,
	"./ship_accident.png": 436,
	"./sma.png": 2011,
	"./smp.png": 2930,
	"./snow_avalanche.png": 6827,
	"./snowfall.png": 9122,
	"./storm.png": 7973,
	"./storm_surge.png": 6338,
	"./tagana.png": 278,
	"./technological.png": 2588,
	"./telkom.png": 2982,
	"./telkomsel.png": 4628,
	"./tenda.png": 622,
	"./terra.png": 1160,
	"./tk.png": 9807,
	"./tni.png": 8633,
	"./tornado.png": 3321,
	"./transportasi.png": 856,
	"./tsunami.png": 4415,
	"./tvone.png": 7456,
	"./universitas.png": 8117,
	"./unknown.gif": 8395,
	"./video.png": 1107,
	"./violent_wind.png": 9610,
	"./volcano.png": 4256,
	"./white.png": 4117,
	"./yellow.png": 9948
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9786;